import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.is-finite.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/esnext.set.add-all.js";
import "core-js/modules/esnext.set.delete-all.js";
import "core-js/modules/esnext.set.difference.js";
import "core-js/modules/esnext.set.every.js";
import "core-js/modules/esnext.set.filter.js";
import "core-js/modules/esnext.set.find.js";
import "core-js/modules/esnext.set.intersection.js";
import "core-js/modules/esnext.set.is-disjoint-from.js";
import "core-js/modules/esnext.set.is-subset-of.js";
import "core-js/modules/esnext.set.is-superset-of.js";
import "core-js/modules/esnext.set.join.js";
import "core-js/modules/esnext.set.map.js";
import "core-js/modules/esnext.set.reduce.js";
import "core-js/modules/esnext.set.some.js";
import "core-js/modules/esnext.set.symmetric-difference.js";
import "core-js/modules/esnext.set.union.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { MetricReportingPeriodType, MetricValueKind } from '~/types/types';
import { encodeReferencePeriodsForQuery, parseReferencePeriodsFromQuery } from '~/functions/referencePeriods';
var FILTER_QUERY_KEYS = ['maStatus', 'maCategoryIds', 'maSidebarSectionIds', 'maYears', 'maIsComputed', 'maValueType', 'maReportingPeriodTypes', 'maAssigneeIds', 'maSectionIds'];
var asQueryArray = function asQueryArray(value) {
  if (!value) return [];
  if (Array.isArray(value)) return value.map(function (item) {
    return String(item);
  }).filter(Boolean);
  return String(value).split(',').map(function (item) {
    return item.trim();
  }).filter(Boolean);
};
var parseBooleanQuery = function parseBooleanQuery(value) {
  var normalized = String(value || '').toLowerCase();
  if (normalized === 'true') return true;
  if (normalized === 'false') return false;
  return null;
};
var parseNumericArrayQuery = function parseNumericArrayQuery(value) {
  return asQueryArray(value).map(function (entry) {
    return Number(entry);
  }).filter(function (entry) {
    return Number.isFinite(entry);
  });
};
var pickManagedQuery = function pickManagedQuery(query) {
  var managed = {};
  for (var _i = 0, _FILTER_QUERY_KEYS = FILTER_QUERY_KEYS; _i < _FILTER_QUERY_KEYS.length; _i++) {
    var key = _FILTER_QUERY_KEYS[_i];
    if (query[key] !== undefined) {
      managed[key] = query[key];
    }
  }
  return managed;
};
export function useMetricAssignmentFilterUrlSync(params) {
  var route = useRoute();
  var router = useRouter();
  var isApplyingRouteFilters = ref(false);
  var hasAppliedInitialStatusDefault = ref(false);
  var applyFiltersFromRoute = function applyFiltersFromRoute() {
    isApplyingRouteFilters.value = true;
    try {
      var entryStatusFromQuery = String(route.query.maStatus || '');
      if (entryStatusFromQuery === 'complete' || entryStatusFromQuery === 'incomplete' || entryStatusFromQuery === 'skipped') {
        params.entryStatusFilter.value = entryStatusFromQuery;
      } else if (params.applyDefaultStatusOnMountOnly.value && hasAppliedInitialStatusDefault.value) {
        // Keep current user-selected status after mount when enabled.
      } else {
        params.entryStatusFilter.value = params.defaultEntryStatus.value;
      }
      hasAppliedInitialStatusDefault.value = true;
      var yearsFromQuery = parseReferencePeriodsFromQuery(route.query.maYears);
      params.displayedReferencePeriods.value = yearsFromQuery.length > 0 ? yearsFromQuery : params.initialReferencePeriods.value;
      params.filteredCategoryIds.value = asQueryArray(route.query.maCategoryIds).map(function (entry) {
        if (entry === 'uncategorized') return 'uncategorized';
        var numeric = Number(entry);
        return Number.isFinite(numeric) ? numeric : entry;
      });
      params.filteredSectionIds.value = parseNumericArrayQuery(route.query.maSidebarSectionIds);
      var validValueKinds = new Set(Object.values(MetricValueKind));
      var valueTypeFromQuery = String(route.query.maValueType || '');
      var validReportingPeriodTypes = new Set(Object.values(MetricReportingPeriodType));
      var reportingPeriodTypesFromQuery = asQueryArray(route.query.maReportingPeriodTypes).filter(function (entry) {
        return validReportingPeriodTypes.has(entry);
      });
      var assigneeQueryRaw = route.query.maAssigneeIds;
      var hasAssigneeIdsQuery = assigneeQueryRaw !== undefined && assigneeQueryRaw !== null;
      var assigneeIdsFromQuery = asQueryArray(assigneeQueryRaw);
      var sectionIdsFromQuery = parseNumericArrayQuery(route.query.maSectionIds);
      var staticAssigneeIds = params.staticAssigneeIds.value;
      var staticSectionIds = params.staticSectionIds.value;
      var existingSectionIds = params.internalFilters.value.sectionIds || [];
      var staticAssigneeIdSet = new Set(staticAssigneeIds || []);
      var staticSectionIdSet = new Set((staticSectionIds || []).map(function (id) {
        return String(id);
      }));
      var assigneeIdsFromQueryWithinStatic = assigneeIdsFromQuery.filter(function (id) {
        return staticAssigneeIdSet.size ? staticAssigneeIdSet.has(id) : true;
      });
      var sectionIdsFromQueryWithinStatic = sectionIdsFromQuery.filter(function (id) {
        return staticSectionIdSet.size ? staticSectionIdSet.has(String(id)) : true;
      });
      params.internalFilters.value = _objectSpread(_objectSpread({}, params.internalFilters.value), {}, {
        isComputed: parseBooleanQuery(route.query.maIsComputed),
        valueType: validValueKinds.has(valueTypeFromQuery) ? valueTypeFromQuery : null,
        reportingPeriodType: reportingPeriodTypesFromQuery,
        // URL query is the source of truth when present.
        // Missing maAssigneeIds + static scope => all selected (default).
        // maAssigneeIds=none (or only invalid ids) => explicitly none.
        assigneeIds: staticAssigneeIds ? hasAssigneeIdsQuery ? assigneeIdsFromQueryWithinStatic : _toConsumableArray(staticAssigneeIds) : assigneeIdsFromQuery,
        sectionIds: staticSectionIds ? sectionIdsFromQueryWithinStatic.length ? sectionIdsFromQueryWithinStatic : (existingSectionIds.length ? existingSectionIds : staticSectionIds).filter(function (id) {
          return staticSectionIdSet.has(String(id));
        }) : sectionIdsFromQuery
      });
    } finally {
      isApplyingRouteFilters.value = false;
    }
  };
  watch(function () {
    return route.query;
  }, function () {
    applyFiltersFromRoute();
  }, {
    immediate: true
  });
  watch([params.entryStatusFilter, params.displayedReferencePeriods, params.filteredCategoryIds, params.filteredSectionIds, function () {
    return params.internalFilters.value.isComputed;
  }, function () {
    return params.internalFilters.value.valueType;
  }, function () {
    return params.internalFilters.value.reportingPeriodType;
  }, function () {
    return params.internalFilters.value.assigneeIds;
  }, function () {
    return params.internalFilters.value.sectionIds;
  }], function () {
    var _params$internalFilte, _params$internalFilte2;
    if (isApplyingRouteFilters.value) return;
    var query = _objectSpread({}, route.query);
    var _iterator = _createForOfIteratorHelper(FILTER_QUERY_KEYS),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var key = _step.value;
        delete query[key];
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    if (params.entryStatusFilter.value !== 'all') {
      query.maStatus = params.entryStatusFilter.value;
    }
    if (params.displayedReferencePeriods.value.length > 0) {
      query.maYears = encodeReferencePeriodsForQuery(params.displayedReferencePeriods.value);
    }
    if (params.filteredCategoryIds.value.length > 0) {
      query.maCategoryIds = params.filteredCategoryIds.value.join(',');
    }
    if (params.filteredSectionIds.value.length > 0) {
      query.maSidebarSectionIds = params.filteredSectionIds.value.join(',');
    }
    if (params.internalFilters.value.isComputed !== null) {
      query.maIsComputed = String(params.internalFilters.value.isComputed);
    }
    if (params.internalFilters.value.valueType) {
      query.maValueType = params.internalFilters.value.valueType;
    }
    if ((_params$internalFilte = params.internalFilters.value.reportingPeriodType) !== null && _params$internalFilte !== void 0 && _params$internalFilte.length) {
      query.maReportingPeriodTypes = params.internalFilters.value.reportingPeriodType.join(',');
    }
    var staticAssigneeIds = params.staticAssigneeIds.value;
    var assigneeIds = params.internalFilters.value.assigneeIds || [];
    if (staticAssigneeIds !== null && staticAssigneeIds !== void 0 && staticAssigneeIds.length) {
      var staticSet = new Set(staticAssigneeIds);
      var isAllSelected = assigneeIds.length === staticAssigneeIds.length && assigneeIds.every(function (id) {
        return staticSet.has(id);
      });
      if (isAllSelected) {
        // Default state: omit param so a fresh load selects all again.
      } else if (assigneeIds.length === 0) {
        query.maAssigneeIds = 'none';
      } else {
        query.maAssigneeIds = assigneeIds.join(',');
      }
    } else if (assigneeIds.length) {
      query.maAssigneeIds = assigneeIds.join(',');
    }
    if ((_params$internalFilte2 = params.internalFilters.value.sectionIds) !== null && _params$internalFilte2 !== void 0 && _params$internalFilte2.length) {
      query.maSectionIds = params.internalFilters.value.sectionIds.join(',');
    }
    var currentManagedQuery = pickManagedQuery(route.query);
    var nextManagedQuery = pickManagedQuery(query);
    if (JSON.stringify(currentManagedQuery) === JSON.stringify(nextManagedQuery)) {
      return;
    }
    router.replace({
      query: query
    });
  }, {
    deep: true
  });
  var hasRouteYearsFilter = computed(function () {
    return Boolean(route.query.maYears);
  });
  return {
    isApplyingRouteFilters: isApplyingRouteFilters,
    applyFiltersFromRoute: applyFiltersFromRoute,
    hasRouteYearsFilter: hasRouteYearsFilter
  };
}